import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 gradient-bg rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">N</span>
              </div>
              <span className="text-xl font-bold gradient-text">NCB</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              零代码建站平台，让产品经理独立完成网站全生命周期开发，无需技术团队支持。
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">产品</h3>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-gray-400 hover:text-white transition-colors">功能介绍</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">产品定价</Link></li>
              <li><Link to="/showcases" className="text-gray-400 hover:text-white transition-colors">成果展示</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">公司</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">关于我们</Link></li>
              <li><Link to="/news" className="text-gray-400 hover:text-white transition-colors">新闻动态</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500 text-sm">
          © 2026 NCB - No Code Builder. All rights reserved.
        </div>
      </div>
    </footer>
  );
}